<template>
  <basic-dialog v-model="dialog" max-width="800px">
    <template v-slot:title>
      <span>{{ $t('support_request') }}</span>
    </template>
    <v-card-text class="pt-4">
      <v-form ref="form">
      <div class="mt-2">{{ $t('support_request_help') }}</div>
      <div v-if="false" :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''" class="my-5">
        {{ $t('required_fields_are_marked_with_asterisk') }} (<span class="red--text">*</span>).
      </div>
      <v-textarea class="mt-5" v-model="details" rows="3" :label="$t('tell_us_about_your_issue')"></v-textarea>
      <v-text-field v-model="name" :label="$t('your_name')"></v-text-field>
      <v-alert text :value="error" type="error">
        {{ $t('error_sending_support_ticket') }}
      </v-alert>
      </v-form>
    </v-card-text>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" text small @click="closeDialog()">{{ $t('dont_send') }}</v-btn>
      <v-btn :loading="loading" color="primary" small @click="sendSupportTicket()">{{ $t('send') }}</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog.vue";

export default {
  name: 'SupportTicketDialog',
  components: {BasicDialog},
  props: {
    apiClient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      message: null,
      loading: false,
      error: false,
      name: '',
      details: '',
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.message = null;
        this.error = false;
        this.name = '';
        this.details = '';

      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    open(message) {
      this.message = message;
      this.dialog = true;
    },
    async sendSupportTicket() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.error = false;

      try {
        const message = await this.apiClient.postSupportTicket(this.message, {
          name: this.name,
          message: this.details,
        });
        this.$emit('ticket-created', message);
        this.dialog = false;
      } catch (error) {
        console.error(error);
        this.error = true;
      }
      this.loading = false;
    }
  }
}

</script>


<style scoped lang="scss">

</style>
